/*
 * @Description: 
 * @Version: 2.0
 * @Author: zhouhong07
 * @Date: 2020-02-11 18:51:44
 * @LastEditors  : zhouhong07
 * @LastEditTime : 2020-02-15 21:20:50
 */
import http5 from './http5' ;
import { getCid, getUid } from './helper' ;
const url = "//zcmoperation.58.com/zcm/operation/api/h5" ;

const indexPageOptions = async () => {
  let params = { cmd : "springwind.homeheader"} ;
  // console.log('params',params);
  let param = {
    url : url ,
    params : params ,
    projectName : ""
  }
  let res = await http5(param);
  // console.log('res',res.result);
  return res.result;
}

const cityPageTimePlace = async (cityid) => {
  let params = { cmd : "springwind.cityheader" , cityid : cityid ||parseInt(getCid()) } ;
  // console.log('params',params);
  let param = {
    url : url ,
    params : params ,
    projectName : ""
  }
  let res = await http5(param);
  // console.log('res',res.result);
  return res.result;
}

//热招职位列表
const cityList = async (cityid , page_no , page_size) => {
 let params = { 
    cmd : "springwind.cityenterpriselist" ,
    cityid : cityid || parseInt(getCid()),
    page_no : page_no,
    page_size : page_size 
  };
  // console.log('params',params);
  let param = {
    url : url ,
    params : params ,
    projectName : ""
  }
  let res = await http5(param);
  // console.log('res',res.result);
  return res.result;

}

const indexVrList = async () => {
  let params = { cmd : "springwind.vrlist"} ;
  // console.log('params',params);
  let param = {
    url : url ,
    params : params ,
    projectName : ""
  }
  let res = await http5(param);
  // console.log('res',res.result);
  return res.result;
}

const indexCityList = async () => {
  let params = { cmd : "springwind.citylist"} ;
  // console.log('params',params);
  let param = {
    url : url ,
    params : params ,
    projectName : ""
  }
  let res = await http5(param);
  // console.log('res',res.result.list);
  return res.result.list;
}

export {
  indexPageOptions ,
  cityPageTimePlace ,
  cityList ,
  indexVrList ,
  indexCityList
}